module.exports = __webpack_public_path__ + "img/welcome.8fc32ad9.svg";